import api from "../api";

function unwrapList(data) {
    return data?.results || (Array.isArray(data) ? data : []);
}

function toApiPath(nextUrl) {
const url = new URL(nextUrl);
return `${url.pathname.replace(/^\/api/, '')}${url.search}`;
}

export async function fetchAllPages(path, params) {
    const items = [];

    let nextPath = path;
    let nextConfig = { params };

    while (nextPath) {
        const res = await api.get(nextPath, nextConfig);

        items.push(...unwrapList(res.data));

        nextPath = res.data?.next
            ? toApiPath(res.data.next)
            : null;

        nextConfig = undefined;
    }

    return items;
}